
export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img 
          src="https://public.readdy.ai/ai/img_res/a365197c4e26a0f7d5f0dad492aa18f4.jpg" 
          alt="서초동 복합개발 프로젝트" 
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>
      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto w-full">
        <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
          서초동 프리미엄<br />복합개발 프로젝트
        </h1>
        <p className="text-xl md:text-2xl text-white/90 mb-10 leading-relaxed">
          8개 필지 통합 개발로 탄생하는 하이엔드 레지던스 오피스텔<br />
          스마트 홈 시스템과 지속가능한 미래를 설계합니다
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button onClick={() => scrollToSection('overview')} className="bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-all cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl">
            프로젝트 살펴보기
          </button>
          <button onClick={() => scrollToSection('contact')} className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-white/20 transition-all cursor-pointer whitespace-nowrap border border-white/30">
            상담 신청하기
          </button>
        </div>
      </div>
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
